import {useQuery} from 'react-query'
import {ResellerEditModalForm} from './ResellerEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getResellerById} from '../core/_requests'

const ResellerEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: reseller,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-reseller-${itemIdForUpdate}`,
    () => {
      return getResellerById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
    )

  if (!itemIdForUpdate) {
    return <ResellerEditModalForm isResellerLoading={isLoading} reseller={{id: undefined}} />
  }

  if (!isLoading && !error && reseller) {
    return <ResellerEditModalForm isResellerLoading={isLoading} reseller={reseller} />
  }

  return null
}

export {ResellerEditModalFormWrapper}
